import { Story } from '../../types/story';

export const berlinLateNightTrain: Story = {
  id: 'berlin-late-night-train',
  title: 'The Last U-Bahn to Neukölln',
  excerpt: 'A missed connection on Berlins late-night U-Bahn turns into something neither of them expected—especially when the train stops running and the city’s rules start to blur.',
  city: 'Berlin',
  publishDate: '2026-01-04',
  readTime: '45 min read',
  tags: ['♂♀', 'late-night', 'public'],
  categories: ['adventurous'],
  intensity: 2,
  content: `
Berlin doesn’t sleep, but it does get tired. By 3 AM, the clubs are still throbbing, but the streets are slick with rain and the air smells like döner grease and cigarette smoke. The U-Bahn runs all night on weekends, but only if you’re lucky—or unlucky, depending on who you ask.

I was on my way home from a shift at the bar in Kreuzberg, my head buzzing from too many free shots and not enough sleep, when I saw *her*.

She was leaning against the pole in the U8, her dark hair a mess, her leather jacket scuffed at the elbows. She had that look—like she’d been dancing for hours and was still vibrating with the bass. Her eyes were half-lidded, her lips slightly parted, and she was staring at me like she was trying to decide if I was worth the effort.

I should’ve looked away. I should’ve pretended I didn’t notice. But I didn’t.

The train lurched, and she stumbled—just a little—but it was enough that she ended up pressed against me. Her hand shot out, gripping my arm for balance, and for a second, we were just two strangers tangled together in the fluorescent glow of the U-Bahn.

“Sorry,” she muttered, but she didn’t move back.

“No problem,” I said, my voice rougher than I meant it to be.

She smelled like sweat and perfume and something sweet, like cherry liqueur. Her fingers were still on my arm, her nails short and painted black.

“You getting off at Neukölln?” she asked.

“Yeah.”

She smirked. “Me too.”

The train was nearly empty by then—just a few drunk kids in the back, a guy passed out in the corner, and us. She didn’t let go of my arm. Instead, she leaned in, her breath hot against my ear.

“You ever do anything reckless on the U-Bahn?” she asked.

I laughed. “Not recently.”

“Good.” She turned her head just enough that her lips brushed my earlobe. “Because I’m about to.”

Before I could react, she kissed me.

It wasn’t soft. It wasn’t sweet. It was hungry, her teeth nipping at my bottom lip, her tongue pushing into my mouth like she was claiming something. I groaned, my hands finding her waist, pulling her closer. She tasted like smoke and something fruity, and I wanted more.

The train rattled on, the fluorescent lights flickering overhead. I didn’t care. I had her pressed against the pole now, my body shielding hers from the rest of the car. Her hands were in my hair, her nails scraping against my scalp, and when I bit down on her lip, she gasped, her hips jerking forward.

“Fuck,” she breathed. “You’re good at that.”

I smirked. “Just wait.”

We made it to Neukölln in a tangle of limbs and half-swallowed moans. The platform was empty, the station lights casting everything in a sickly yellow glow. She pulled me into a corner, out of sight of the security cameras, and pushed me against the tiled wall.

“You live far?” she asked, her voice husky.

“Five minutes.”

She grinned. “Perfect.”

Her hands were on my belt before I could answer, yanking it open, then my jeans. I hissed as the cold air hit my skin, but her fingers were already wrapping around me, her grip firm.

“You’re hard as fuck,” she murmured, stroking me slow, her thumb swiping over the head. “You like this, huh? Getting off in public?”

I groaned, my head falling back against the wall. “Yes.”

She chuckled, low and dark. “Me too.”

Then she dropped to her knees.

---

The first touch of her tongue was electric. She didn’t tease—she took me in deep, her lips sealing around the base, her tongue working the underside. I tangled my fingers in her hair, my breath coming in sharp gasps.

“Fuck—”

She pulled off just long enough to look up at me, her lips glistening. “Quiet, or someone’ll hear.”

I bit my lip hard enough to taste blood.

She went back to work, her mouth hot and wet, her hand cupping my balls, squeezing just enough to make my knees weak. The sounds she made—wet, obscene—echoed in the empty station, and I knew if anyone walked by, they’d hear. They’d *know*.

And that just made me harder.

---

She didn’t let me come.

Not there, at least.

She stood up, wiping her mouth with the back of her hand, her eyes dark with promise. “My place is closer,” she said, her voice rough. “Let’s go.”

I didn’t argue.

---

Her apartment was in a crumbling Altbau near the canal, the kind with high ceilings and drafty windows. The second the door shut behind us, she was on me again, her mouth crashing into mine, her hands shoving my jacket off my shoulders.

“I want you to fuck me,” she said against my lips. “Hard. Like you mean it.”

I didn’t need to be told twice.

---

The bed was narrow, the sheets cold, but neither of us cared. I had her on her back in seconds, her legs wrapped around my waist, her nails digging into my shoulders. She was wet, so fucking wet, and when I pushed into her, she arched off the bed with a broken moan.

“Yes—*just like that*—”

I set a brutal pace, the bedframe knocking against the wall, the sound of skin slapping skin filling the room. She met me thrust for thrust, her heels digging into my ass, her breath hot against my neck.

“More,” she gasped. “I want more.”

I flipped her over, pulling her up onto her knees. She braced herself against the headboard, her back arching as I drove into her from behind, my hands gripping her hips hard enough to leave bruises.

“Like this?” I growled.

“Yes—*fuck*—”

I reached around, my fingers finding her clit, rubbing in tight circles as I fucked her. She came with a cry, her body clenching around me, and I followed her over the edge, my release spilling into her as I buried my face in her hair.

---

Afterward, we lay tangled in the sheets, her head on my chest, my fingers tracing idle patterns on her skin.

“What’s your name?” I asked.

She laughed, low and breathless. “I don’t think we got to that part.”

I grinned. “We can skip it, if you want.”

She propped herself up on one elbow, her dark eyes glinting in the dim light. “Nora.”

“Lukas.”

She kissed me, slow this time. “Nice to meet you, Lukas.”

Outside, the first hints of dawn were creeping over the rooftops. Somewhere, a tram rumbled by.

I pulled her closer.

“You think we can do this again sometime?” I asked.

She smirked. “I think we *have* to.”

And just like that, the last U-Bahn to Neukölln became the first ride of something new.
` };
